import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dynamicSearchFilter'
})
export class DynamicSearchFilterPipe implements PipeTransform {
  transform(value: any[], queryString?: string, type?: string): any {
    if (!queryString) {
      return value;
    }
    let searchRegExp;
    if (queryString === '(' || queryString === ')') {
      searchRegExp = new RegExp('\\(|\\)');
    } else {
      searchRegExp = new RegExp(queryString, 'i');
    }
    return value.filter(data => searchRegExp.test(data[type || 'key']));
  }
}
